import { initializeApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAbiVqPTuFNQJikEUPMKS8BCH_i7sEraEU",
  authDomain: "acgsalestool.firebaseapp.com",
  projectId: "acgsalestool",
  storageBucket: "acgsalestool.firebasestorage.app",
  messagingSenderId: "1078989046043",
  appId: "1:1078989046043:web:1a3394e28df067f8ccd3be",
  measurementId: "G-G8HGE3E9SB",
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);

setPersistence(auth, browserLocalPersistence).catch((error) => {
  console.error("Firebase persistence error:", error);
});

export { firebaseApp as app, auth };
